module.exports = __webpack_public_path__ + "static/img/Queen of Swords.1ed91e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Queen of Swords.jpg
// module id = 1293
// module chunks = 0